import { path, assocPath } from "ramda";
import { curryN } from "ramda";
export const updatePath = (p, f, x) => {
    const valueAtPath = path(p, x);
    return assocPath(p, f(valueAtPath), x);
};
export default curryN(3, updatePath);
//# sourceMappingURL=updatePath.mjs.map